import { BreadcrumbService } from '../../core/services/breadcrumb.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IBreadcrumb } from './breadcrumb.model';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TimepointCtx, TimepointService } from '../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { HistoryMode } from '../../core/services/HistoryMode';
import { AppConfigService } from '../../core/services/app-config.service';
import { AppPermissionService } from '../../core/services/app-permission.service';
import { FunctionbarComponent } from '../functionbar/functionbar/functionbar.component';
import { DatePipe, NgClass } from '@angular/common';
import { FunctionbarListComponent } from '../functionbar/functionbar-list';
import { FormsModule } from '@angular/forms';
import { MetaDisablerDirective } from '../directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../directives/meta-validator.directive';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormatTimepointPipe } from '../pipes/format/format-timepoint.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [
    FunctionbarComponent,
    NgClass,
    FunctionbarListComponent,
    FormsModule,
    MetaDisablerDirective,
    MetaValidatorDirective,
    NgbTooltip,
    DatePipe,
    TranslatePipe,
    FormatTimepointPipe
  ]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  breadcrumbHolder: IBreadcrumb[];
  timepointCtx: TimepointCtx;
  private timepointServiceSub: Subscription;

  private subscription: Subscription = new Subscription();

  historyModeCheckbox = false;

  constructor(
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private appConfigService: AppConfigService,
    private permissionService: AppPermissionService,
    private timepointService: TimepointService
  ) {
    keysToTranslate<string>(['shared.breadcrumb.list', 'recht.search.breadcrumb', 'GeschichteAnzeigen']);
    this.timepointServiceSub = this.timepointService.timePoint$.subscribe((ctx) => (this.timepointCtx = ctx));
    this.subscription.add(
      appConfigService.einstellungHistorischeDaten$.subscribe(
        (hist) => (this.historyModeCheckbox = hist === HistoryMode.HistoryMode.MIT_HIST)
      )
    );
  }

  ngOnInit() {
    this.breadcrumbHolder = this.breadcrumbService.getBreadcrumbs();
  }

  ngOnDestroy(): void {
    this.timepointServiceSub.unsubscribe();
  }

  breadcrumbClicked(i: number) {
    this.router.navigateByUrl(this.breadcrumbHolder[i].url);
  }

  resetTimepoint() {
    this.timepointService.resetTimepoint();
  }

  onSelectHistorisiert() {
    this.appConfigService.switchEinstellungHistorischeDaten();
  }

  get hasPermissionAnzeigeHistorischeEintraege() {
    return this.permissionService.hasPermission('ANZEIGE_HISTORISCHE_EINTRAEGE');
  }
}
